import { toArray } from '../../utils/array'
import { parseNumber } from '../../utils/number'

export type MeasurableForPieces = {
  packageCount?: string | number | null
  commodities?: Array<{ packageCount?: string | number | null }> | null
}

/**
 * Total commodity package counts across all handling units; per HU, if that sum is 0,
 * falls back to that HU's package_count (legacy / empty commodity rows).
 */
export function sumCommodityPackageCountsFromMeasurables(
  measurables?: MeasurableForPieces | MeasurableForPieces[] | null
): number {
  return toArray(measurables).reduce((total, hu) => {
    const commodities = hu.commodities ?? []
    const fromCommodities = commodities.reduce(
      (sub, commodity) => sub + (parseNumber(commodity.packageCount) || 0),
      0
    )
    const huContribution = fromCommodities || (parseNumber(hu.packageCount) || 0)
    return total + huContribution
  }, 0)
}

export function sumCommodityPackageCountsForSummary(
  shippingItems: MeasurableForPieces[]
): number {
  return sumCommodityPackageCountsFromMeasurables(shippingItems)
}
